/**
 * Purpose of this view is to show user's profile & login data,
 * such as API keys, with option to clear them/logout.
 */
<template>
    <div class="columns is-flex-mobile">
        <div class="column is-one-third">
            <div class="content-white is-dark">
                <img src="../assets/logo.png" alt="">
                <div class="user-content is-size-10 is-family-primary">
                    User
                    <div class="is-size-6 is-family-secondary">
                        <label class="label">
                            {{ $t("message.apiKeyView") }}
                        </label>
                        <p>{{ apiKey }}</p>

                        <label class="label">
                            {{ $t("message.momaKeyView") }}
                        </label>
                        <p>{{ momaKey }}</p>
                    </div>
                    <div class="options-content mt-3">
                        <a type="button"
                            class="button is-secondary is-large is-uppercase mr-1"
                            @click="clearKeys">
                            {{ $t("message.logoutButton") }}
                        </a>
                            <router-link
                                type="button"
                                class="button is-primary is-large is-uppercase"
                                to="/">
                                {{ $t("message.goMap") }}
                            </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="column logged-background-image"></div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';

export default {
    name: 'Profile',

    computed: {
        ...mapState(['apiKey', 'momaKey']),
        ...mapGetters(['isAuthorized']),
    },

    methods: {
        ...mapMutations(['clearKeys']),
    },

    watch: {
        /**
         * When there is change in authorization, redirect to `/auth`,
         * replacing current history entry.
         */
        isAuthorized() {
            this.$router.replace('/auth');
        },
    },
};
</script>
